(function($) {

$(document).ready(function(){
	if ($('.product').length) {
		$('.product').on('mouseenter touchstart',function(){
			$(this).find('.product__popup').stop().slideDown();
		});
		$('.product').on('mouseleave touchend',function(){
			$(this).find('.product__popup').stop().slideUp();
		});		
	}
	if ($('.productSingle').length) {
		adjustRight();
		$(window).on('resize',adjustRight);
		$('.nutrition-facts').on('click',function(){
			$('#nutrition-facts').fadeIn();
		});
	}
});

function adjustRight() {
	var scene 		= $('.scene');
	var sceneH		= scene.outerHeight();
	var title 	 	= $('.scene__title');		
	var titleH		= title.outerHeight();
	var titleOffset = 100;
	var rightOffset	= 50;

	var newTop 		= sceneH - titleH - titleOffset - rightOffset;
	$('.productSingle__right').stop().animate({marginTop:-newTop},600);
}

})( jQuery );  